import { getTestTaskRecords } from "../utils/TestRecordUtils";
import { TASK_TEST_RECORD_COUNT } from "../constants/constants";

//Todo
//added this file and function as a placeholder and added dummy data for page mock up
//after adding implementation logic and unit tests remove this file from test coverage exclude list
export const getTasksAPI = () => {
  return getTestTaskRecords(TASK_TEST_RECORD_COUNT);
};
